
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { Event, Trip, TripMutation, TripStop } from '@clients/myTrips';
import MapboxConfig from '@/config/MapboxConfig';
import TripsMap from '@components/trip-detail/maplib/TripsMap.vue';

@Component({
  name: 'TripDetailMap',
  components: {
    TripsMap
  }
})

export default class TripDetailMap extends Vue {
  @Prop()
  private trip: Trip;

  @Prop()
  private tripMutation: TripMutation;

  @Prop()
  private events: Array<Event>;

  @Prop({ default: true })
  private interactive: boolean

  @Prop()
  private fullscreen: boolean;

  get currentTrip() {
    return this.tripMutation || this.trip;
  }

  get mapboxAccessToken() {
    return MapboxConfig.accessToken;
  }

  get startPoint() {
    if (!this.currentTrip) {
      return null;
    }
    const startInfo = this.currentTrip.startInfo;
    return (startInfo && startInfo.location && startInfo.location.latitude && startInfo.location.longitude) ? { lng: startInfo.location.longitude, lat: startInfo.location.latitude } : null;
  }

  get endPoint() {
    if (!this.currentTrip) {
      return null;
    }
    const endInfo = this.currentTrip.endInfo;
    return (endInfo && endInfo.location && endInfo.location.latitude && endInfo.location.longitude) ? { lng: endInfo.location.longitude, lat: endInfo.location.latitude } : null;
  }

  get stops() {
    let tripStops: Array<TripStop> = [];
    if (this.currentTrip && this.currentTrip.stops && Array.isArray(this.currentTrip.stops)) {
      tripStops = this.currentTrip.stops;
    }
    return tripStops.filter(stop => stop && stop.location && stop.location.longitude && stop.location.latitude)
      .map(stop => ({ lng: stop.location.longitude, lat: stop.location.latitude }));
  }

  get lineCoordinates() {
    if (this.currentTrip && this.currentTrip.routeGeometry) {
      const routeGeometry = this.currentTrip.routeGeometry;
      return routeGeometry.replace('LINESTRING', '').replace('( ', '').replace(' )', '').split(',').map((coordinate) => {
        const splitted = coordinate.split(' ');
        return { lng: +splitted[0], lat: +splitted[1] };
      });
    }
    return [];
  }
}
